import type { ReactNode } from 'react'
import React from 'react'
import * as S from './styled'

type Props = {
  top: ReactNode
  bottom?: ReactNode
  image?: ReactNode
}

export const EntityTableCell = ({ top, bottom, image }: Props) => {
  return (
    <S.Container>
      {image !== undefined && (
        <S.ImageContainer data-testid="EntityTableCell.ImageContainer">{image}</S.ImageContainer>
      )}
      <S.Content>
        <S.TopContainer>{top}</S.TopContainer>
        {bottom !== undefined && (
          <S.BottomContainer data-testid="EntityTableCell.BottomContainer">
            {bottom}
          </S.BottomContainer>
        )}
      </S.Content>
    </S.Container>
  )
}
